import InsertCardOrderSummary from './insert-card-order-summary'

export default InsertCardOrderSummary
